module.exports = __webpack_public_path__ + "static/media/bikeForeground.83838cc9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/CommitView/Bike/bikeForeground.svg
// module id = 909
// module chunks = 0